import { render, staticRenderFns } from "./FinancialPlanningStep2.vue?vue&type=template&id=e47e508e&scoped=true"
import script from "./FinancialPlanningStep2.vue?vue&type=script&lang=js"
export * from "./FinancialPlanningStep2.vue?vue&type=script&lang=js"
import style0 from "./FinancialPlanningStep2.vue?vue&type=style&index=0&id=e47e508e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47e508e",
  null
  
)

export default component.exports